import classNames from 'classnames/bind';
import Spinner from 'components/Spinner/Spinner';
import HeaderList from '../../../../components/HeaderList/HeaderList';
import styles from './AccountPage.module.css';

const cx = classNames.bind(styles);

/** @typedef {import('react').ReactNode} ReactNode */

/**
 * Annotated rather than rewritten. In a `.js` file a parameter defaulted to
 * `null` is inferred as type `null`, so every page passing a `cta` or
 * `topContent` element was an error; `headerProps` and `children`, which have no
 * default, were inferred as required. The JS is untouched.
 *
 * @param {{ headerProps?: any, sections?: any[], loading?: boolean,
 *   cta?: ReactNode, topContent?: ReactNode, belowHeaderContent?: ReactNode,
 *   children?: ReactNode }} props
 */
export default function AccountPage({
  headerProps,
  sections = [],
  loading = false,
  cta = null,
  topContent = /** @type {import('react').ReactNode} */ (null),
  belowHeaderContent = /** @type {import('react').ReactNode} */ (null),
  children,
}) {
  return (
    <>
      <div className={cx('page')}>
        {topContent && <div className={cx('topContent')}>{topContent}</div>}
        <div className={cx('header')}>
          <HeaderList {...headerProps} cta={cta} />
        </div>
        {belowHeaderContent && (
          <div className={cx('belowHeaderContent')}>{belowHeaderContent}</div>
        )}
        {loading && <Spinner />}
        <div className={cx('content')}>
          {sections.map((section, index) => (
            <div key={index} className={cx('section')}>
              {section.title && (
                <h3 className={cx('title')}>{section.title}</h3>
              )}
              {section.subtitle && (
                <div className={cx('subtitle')}>{section.subtitle}</div>
              )}
              <div className={cx('section-content')}>{section.content}</div>
            </div>
          ))}
          {children}
        </div>
      </div>
    </>
  );
}
